import { lazy } from 'react';

import { RouteItem } from '@/base/RenderRouter';
import LazyLoad from '@/routes/lazyLoad';

const imRouter: RouteItem[] = [
  {
    path: '/im',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'IM聊天',
      key: 'imHome',
    },
  },
  {
    path: '/im/create-bot',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '创建智能体',
      key: 'createBot',
    },
  },
  {
    path: '/im/contacts',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '联系人',
      key: 'contacts',
    },
  },
  {
    path: '/im/notes',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '笔记',
      key: 'notes',
    },
  },
  {
    path: '/im/notes/view/:id',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '笔记详情',
      key: 'notesView',
    },
  },
  {
    path: '/im/notes/edit/:id',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '编辑笔记',
      key: 'notesEdit',
    },
  },
  {
    path: '/im/notes/create-ip',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '创建IP',
      key: 'createIp',
    },
  },
  {
    path: '/im/notes/agents',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '智能体笔记',
      key: 'createAgent',
    },
  },
  {
    path: '/im/notes/content-edit/:id',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '创作视频',
      key: 'contentEdit',
    },
  },
  {
    path: '/im/voice-clone',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'AI声音克隆',
      key: 'voiceClone',
    },
  },
  {
    path: '/im/video-clone',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'AI视频克隆',
      key: 'videoClone',
    },
  },
  {
    path: '/im/content-library',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '内容库',
      key: 'contentLibrary',
    },
  },
  {
    path: '/im/chat/:conversationId',
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'IM聊天',
      key: 'imChat',
    },
  },
  {
    path: '/im/ai',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'AI智能体',
      key: 'ai',
    },
  },
  {
    path: '/im/ai/chat/:chatId',
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'AI对话',
      key: 'aiChat',
    },
  },
  {
    path: '/im/ai/user',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '创建智能体',
      key: 'aiUser',
    },
  },
  {
    path: '/im/ai/website-generator',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'AI生成官网',
      key: 'aiWebsiteGenerator',
    },
  },
  {
    path: '/site/:siteCode',
    caseSensitive: true,
    element: LazyLoad(
      lazy(() => import('@/pages/ai/components/WebsitePublishedPage/index'))
    ),
    meta: {
      title: '企业官网',
      key: 'aiPublishedWebsite',
    },
  },
  {
    path: '/im/agents',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '首页',
      key: 'agents',
    },
  },
  {
    path: '/im/clone',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '我的分身',
      key: 'clone',
    },
  },
  {
    path: '/im/address-book',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '通讯录',
      key: 'addressBook',
    },
  },
  {
    path: '/im/group-buy',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'AI商城',
      key: 'groupBuy',
    },
  },
  {
    path: '/im/project-management',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '项目管理',
      key: 'projectManagement',
    },
  },
  {
    path: '/im/project-management/projects',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '项目列表',
      key: 'projectList',
    },
  },
  {
    path: '/im/project-management/projects/:id',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '项目详情',
      key: 'projectDetail',
    },
  },
  {
    path: '/im/project-management/resources',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '资源库',
      key: 'projectResources',
    },
  },
  {
    path: '/im/project-management/todos',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '项目待办',
      key: 'projectTodos',
    }
  },
  {
    path: '/im/overseas-platform',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '海外平台授权',
      key: 'overseasPlatform',
    },
  },
  {
    path: '/im/square',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: 'AI社交',
      key: 'square',
    },
  },
  {
    path: '/im/square/agent/:botId',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '智能体主页',
      key: 'squareAgent',
    },
  },
  {
    path: '/im/square/post/:postId',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '精选详情',
      key: 'squarePostDetail',
    },
  },
  {
    path: '/im/super-admin',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '超级管理员',
      key: 'superAdmin',
    },
  },
  {
    path: '/im/super-admin/:subView',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/index'))),
    meta: {
      title: '超级管理员',
      key: 'superAdminSub',
    },
  },
  {
    path: '/im/ai/share/:botid',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/ai/share/index'))),
    meta: {
      title: '关注智能体',
      key: 'aiShare',
    },
  },
  {
    path: '/im/ai/msg-share/:shareCode',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/ai/msgShare/index'))),
    meta: {
      title: '消息分享',
      key: 'aiMsgShare',
    },
  },
  {
    path: '/im/notes/share/:noteId',
    caseSensitive: true,
    element: LazyLoad(lazy(() => import('@/pages/im/noteShare/index'))),
    meta: {
      title: '笔记分享',
      key: 'noteShare',
    },
  },
];

export default imRouter;
